import styled from "styled-components";

export const BatchNameComponent = styled.div`
  max-width: 150px;
  min-width: 100px;
  word-wrap: break-word;
  display: inline-block;
`;
